import { DisplayElementModel } from '../../../Common/PageBuilder/models/display-element.model';
import { SocialLinkStyleModel } from '../../../Common/PageBuilder/models/link-style.model';
import { WireSocialLinkEnum } from '../enums/wire-social-link.enum';
import { SocialLinkDisplayElementApiModel } from './social-link-display-element-api.model';
import { WireSocialLinkModel } from './wire-social-link.model';


export class SocialLinkDisplayElementModel extends DisplayElementModel {
    declare styles: SocialLinkStyleModel;
    socialLinks: WireSocialLinkModel[] = [];

    // currently wire only uses these style fields
    styleCompareFields = [
        'alignment',
        'fontSize',
        'italics',
        'bold',
        'underlined'
    ];

    constructor(
        apiData: SocialLinkDisplayElementApiModel
    ) {
        super();
        this.isBoundToGlobalStyles = true;

        if (apiData) {
            apiData.socialLinks.forEach(link => {
                this.socialLinks.push(new WireSocialLinkModel(link));
            });
            this.styles = new SocialLinkStyleModel(apiData.styles);
        } else {
            this.socialLinks.push(new WireSocialLinkModel({
                linkType: WireSocialLinkEnum.TWITTER,
                url: '',
                text: '',
            } as WireSocialLinkModel));
            this.styles = new SocialLinkStyleModel();
        }
    }

    canRender(): boolean {
        let canRender = false;
        this.socialLinks.forEach(link => {
            if (link.url) {
                canRender = true;
            }
        });

        return canRender;
    }

    clone(): SocialLinkDisplayElementModel {
        const clone = new SocialLinkDisplayElementModel(this.toApiModel());
        clone.displayType = this.displayType;

        return clone;
    }

    onUpdate(): boolean {
        return true;
    }

    isEqual(other: SocialLinkDisplayElementModel): boolean {
        if (!other || !other.socialLinks) {
            return false;
        }

        // Compare social Links
        for (let i = 0; i < this.socialLinks.length; i++) {
            if (!this.socialLinks[i].equals(other.socialLinks[i])) {
                return false;
            }
        }

        // Compare style fields
        for (let i = 0; i < this.styleCompareFields.length; i++) {
            const field = this.styleCompareFields[i];
            if (this.styles[field] !== other.styles[field]) {
                return false;
            }
        }

        return true;
    }

    toApiModel(): SocialLinkDisplayElementApiModel {
        const apiModel = Object.assign(
            {},
            <SocialLinkDisplayElementApiModel> {
                socialLinks: this.socialLinks.map(link => link.toApiModel()),
                styles: JSON.parse(JSON.stringify(this.styles))
            },
        );

        return apiModel;
    }
}
